export default class WpidSearchResult {
  constructor(data, wpidNbr) {
    this.wpidNbr = wpidNbr;
    this.itemNbr = data['itemNbr'];
    const itemDesc = data['itemDesc'] ?? '';
    this.itemDesc = itemDesc.trim();
    const item2Desc = data['item2Desc'] ?? '';
    this.item2Desc = item2Desc.trim();
    this.legacyItemNbr = data['legacyItemNbr'] ?? null;
    this.vendorNbr = data['nineDigitVendorNbr'] ?? data['vendorNbr'] ?? null;
    const vendorName = data['vendorName'] ?? '';
    this.vendorName = vendorName.trim();
    this.upcNbr = data['upcNbr'] ?? null;
    this.category = data['category'] ?? null;
    this.itemImgUrl = this.upcNbr
      ? `https://scene7.samsclub.com/is/image/samsclub/` +
        '0'.repeat(13 - this.upcNbr.toString().length) +
        this.upcNbr
      : '/No_Image.jpg';
  }
}
